import React, { useEffect, useState } from "react";
import NavBar from "../../Component/NavBar/NavBar";
import { MdOutlineBlock, MdOutlineVerifiedUser } from "react-icons/md";
import { IoIosAddCircleOutline } from "react-icons/io";
import apiRequests from "../../Component/axios/config/config";
import Loading from "../../Component/Loading/Loading";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { BiSolidUserDetail } from "react-icons/bi";
import Pagination from "../../Component/pagination/Pagination";
import { ModalAddSeller } from "./AddSeller";

const listEndpoints = {
  seller: "/api/seller/v1/get-sellersList-by-admin",
  chef: "/api/seller/v1/get-chefsList-by-admin",
};

export default function Seller() {
  const navigate = useNavigate();
  const [sellerType, setSellerType] = useState("seller");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checkStatus, setCheckStatus] = useState("All User");

  const [UserBlock, setUserBlock] = useState("");

  // const [showModalEdit, setShowModalEdit] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);

  const [showModalDelete, setShowModalDelete] = useState(false);
  const [name, setName] = useState(false);
  const [UserId, setUserId] = useState("");
  const [statusUsers, setStatusUsers] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");

  function apiGetUser(pageNumber = page, search, type = sellerType) {
    setLoading(true);
    apiRequests
      .get(listEndpoints[type], {
        params: {
          isDeleted: UserBlock,
          page: pageNumber,
          limit: 20,
          search,
        },
      })
      .then((response) => {
        setUsers(response.data.data.docs);
        setTotalPages(response.data.data.totalPages || 1);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    apiGetUser(page, search, sellerType);
  }, [page, UserBlock, sellerType]);

  function handleSearch(value) {
    setSearch(value);
    setPage(1);
    apiGetUser(1, value);
  }

  function goToPage(newPage) {
    if (newPage < 1 || newPage > totalPages) return;
    setPage(newPage);
  }

  function EditUser(id) {
    navigate(`/seller/${id}`);
  }

  function ChangeStatusUser(id, name, status) {
    setShowModalDelete(true);
    setStatusUsers(status);
    setName(name);
    setUserId(id);
  }

  return (
    <div className="p-6">
      <div className="text-3xl font-bold text-gray-800 mb-6">
        {sellerType === "chef" ? "Chefs Management" : "Sellers Management"}
      </div>

      <div className="flex gap-2 mb-4">
        <button
          className={`px-4 py-2 rounded-lg font-medium ${
            sellerType === "seller"
              ? "bg-firstColor-shade4 text-white"
              : "bg-gray-100 text-gray-600"
          }`}
          onClick={() => {
            setSellerType("seller");
            setPage(1);
          }}
        >
          Sellers
        </button>
        <button
          className={`px-4 py-2 rounded-lg font-medium ${
            sellerType === "chef"
              ? "bg-firstColor-shade4 text-white"
              : "bg-gray-100 text-gray-600"
          }`}
          onClick={() => {
            setSellerType("chef");
            setPage(1);
          }}
        >
          Chefs
        </button>
      </div>

      <NavBar
        item={[
          {
            icon: <BiSolidUserDetail style={{ fontSize: "22px" }} />,
            title: "All Sellers",
            value: checkStatus,
            onClick: () => {
              setUserBlock("");
              setCheckStatus("All User");
            },
          },
          {
            icon: <MdOutlineVerifiedUser />,
            title: "Active Sellers",
            value: checkStatus,
            onClick: () => {
              setUserBlock(false);
              setCheckStatus("Active User");
            },
          },
          {
            icon: <MdOutlineBlock />,
            title: "Blocked Sellers",
            value: checkStatus,
            onClick: () => {
              setUserBlock(true);
              setCheckStatus("Block User");
            },
          },
          {
            icon: <IoIosAddCircleOutline />,
            title: "Add Seller",
            onClick: () => setShowAddModal(true),
          },
        ]}
        onSearch={handleSearch}
      />

      <div className="flex justify-center mt-8">
        <div className="w-full max-w-6xl md:overflow-x-auto">
          <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
            <thead className="bg-gradient-to-r text-left from-buttonColor-shade4 to-marginColor-shade9 text-white">
              <tr>
                <th className="px-4 py-2 text-md font-medium rounded-tl-lg">
                  User Name
                </th>
                <th className="px-4 py-2 text-md font-medium">Mobile Number</th>
                <th className="px-4 py-2 text-md font-medium">
                  Account Status
                </th>
                <th className="px-4 py-2 text-md font-medium">
                  Approval Status
                </th>

                <th className="px-4 py-2 text-md font-medium rounded-tr-lg">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td className="px-4 py-3 text-center" colSpan="4">
                    <Loading />
                  </td>
                </tr>
              ) : users.length > 0 ? (
                users.map((item) => (
                  <tr key={item._id}>
                    <td className="px-4 py-2 text-md font-medium rounded-tl-lg">
                      {item.userName || "-"}
                    </td>
                    <td className="px-4 py-2 text-md font-medium">
                      {item.mobile}
                    </td>
                    <td className={`px-4 py-4`}>
                      <span
                        className={`px-2 hover:cursor-pointer py-1 rounded-full text-xs font-medium 
                                            ${item.isDeleted ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"}`}
                        onClick={() =>
                          ChangeStatusUser(
                            item._id,
                            item.userName,
                            item.isDeleted,
                          )
                        }
                      >
                        {item.isDeleted ? "Deleted" : "Active"}
                      </span>
                    </td>
                    <td className="px-4 py-4">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-medium
      ${
        item.status === "pending"
          ? "bg-yellow-100 text-yellow-700"
          : item.status === "accepted"
            ? "bg-green-100 text-green-700"
            : "bg-red-100 text-red-700"
      }
    `}
                      >
                        {item.status === "pending"
                          ? "Pending"
                          : item.status === "accepted"
                            ? "Accepted"
                            : "Rejected"}
                      </span>
                    </td>
                    <td className="px-4 py-2 text-md font-medium rounded-tr-lg">
                      <button
                        className="text-blue-500 hover:text-blue-700 font-medium mr-4"
                        onClick={() => EditUser(item._id)}
                      >
                        Edit
                      </button>
                      {/*<button*/}
                      {/*    className="text-red-500 hover:text-red-700 font-medium"*/}
                      {/*>*/}
                      {/*    Delete*/}
                      {/*</button>*/}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="">
                  <td className="px-4 py-3 text-center" colSpan="4">
                    {sellerType === "chef"
                      ? "Chef not found!"
                      : "Seller not found!"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {!loading && users.length > 0 && (
            <Pagination
              page={page}
              totalPages={totalPages}
              onPageChange={goToPage}
            />
          )}
        </div>
      </div>

      {showModalDelete && (
        <ModalChangeStatus
          setShow={setShowModalDelete}
          name={name}
          status={statusUsers}
          apiGetUser={apiGetUser}
          id={UserId}
        />
      )}

      {showAddModal && (
        <ModalAddSeller setShow={setShowAddModal} apiGetUser={apiGetUser} />
      )}
    </div>
  );
}

export function ModalChangeStatus({ setShow, id, name, apiGetUser, status }) {
  const [loading, setLoading] = useState(false);

  function ChangeStatus() {
    setLoading(true);
    apiRequests
      .delete(
        status
          ? `/api/seller/v1/unblock-seller-admin`
          : `/api/seller/v1/block-seller-admin`,
        {
          data: {
            sellerId: id,
          },
        },
      )
      .then((res) => {
        toast.success(res.data.en_message);
        setShow(false);
        apiGetUser();
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }

  return (
    <div className="report-modal fixed inset-0 bg-black bg-opacity-60 transition-opacity">
      <div className="flex min-h-full items-end justify-center p-3 text-center">
        <div className="modal relative text-black transform overflow-hidden rounded-lg bg-white p-8 w-[30%] md:w-[90%] m-auto flex flex-col gap-5">
          <div className="text-gray-500">
            Do you want to change the status of
            <span className="text-firstColor-shade9 font-bold"> {name} </span>?
          </div>

          <div className="flex justify-center items-center gap-5 ">
            <button
              className={`px-4 py-1 border-2  ${status ? `hover:bg-firstColor-shade4 hover:text-white border-firstColor-shade4 text-firstColor-shade4` : `hover:bg-red-600 hover:text-white border-red-600 text-red-600`}  rounded-lg `}
              onClick={ChangeStatus}
            >
              {loading ? (
                <Loading textColor={status && `white-0`} />
              ) : status ? (
                "Unblock"
              ) : (
                "block"
              )}
            </button>

            <button
              className="hover:bg-gray-300 border-2 px-4 py-1 rounded-lg"
              onClick={() => setShow(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
